// Find (M12, AC-FIND-1): where a search text occurs in a line's text. Case is ignored unless asked; runs of
// whitespace count as one space (in the line and in the search text). Offsets are into the line's own text.

/** Lower case, character by character where that keeps the length (offsets must stay true to the original text). */
function folded(text: string): string {
  const all = text.toLocaleLowerCase();
  if (all.length === text.length) return all;
  return [...text].map((c) => (c.toLocaleLowerCase().length === c.length ? c.toLocaleLowerCase() : c)).join('');
}

/** Every occurrence of `query` in `text` (not overlapping), as [start, end) offsets into `text`. */
export function findInText(text: string, query: string, matchCase = false): [number, number][] {
  const q = query.trim().replace(/\s+/g, ' ');
  if (!q) return [];
  // The line with whitespace runs made one space, and where each kept character was in the original.
  let flat = '';
  const at: number[] = [];
  for (let i = 0; i < text.length; i++) {
    const space = /\s/.test(text[i]);
    if (space && flat.endsWith(' ')) continue;
    at.push(i);
    flat += space ? ' ' : text[i];
  }
  at.push(text.length);
  const hay = matchCase ? flat : folded(flat);
  const needle = matchCase ? q : folded(q);
  const out: [number, number][] = [];
  for (let k = hay.indexOf(needle); k >= 0; k = hay.indexOf(needle, k + needle.length)) {
    // The end: just past the match's last character in the original (not past the whitespace after it).
    out.push([at[k], at[k + needle.length - 1] + 1]);
  }
  return out;
}

/** The line's text with each [start, end) range replaced by `by` (ranges in order, not overlapping). */
export function replaceRanges(text: string, ranges: [number, number][], by: string): string {
  let out = '';
  let pos = 0;
  for (const [a, b] of [...ranges].sort((p, q) => p[0] - q[0])) {
    out += text.slice(pos, a) + by;
    pos = b;
  }
  return out + text.slice(pos);
}
